export default {
  form: {
    amount: {
      label: 'Pris',
    },
    threshold: {
      label: 'Månedligt salg',
    },
    has_pricing_tiers: {
      label: 'Prisen ændres ud fra månedligt salg',
    },
    tax_included: {
      label: 'Moms inkluderet',
    },
  },
  buttons: {
    add_tier: 'Tilføj trin',
  },
};
